export enum IconsEnum {
  APPLICATION = 'flaticon-application',
  CLOSE = 'flaticon-close',
  ERROR = 'flaticon-error',
}
